class ProductSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector("[data-slider]");
    this.prevBtn = this.querySelector("[data-prev]");
    this.nextBtn = this.querySelector("[data-next]");
    this.dots = this.querySelectorAll("[data-dot]");

    if (!this.slider) return;

    this.init();
  }

  init() {
    this.slider.addEventListener(
      "scroll",
      () => {
        this.updateDots();
      },
      { passive: true }
    );

    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.target.closest("button").blur();
        this.scroll("left");
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.target.closest("button").blur();
        this.scroll("right");
      });
    }
  }

  scroll(direction) {
    const width = this.slider.clientWidth;
    const scrollAmount = direction === "left" ? -width : width;

    this.slider.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  }

  updateDots() {
    if (!this.dots.length) return;

    const width = this.slider.clientWidth;
    const scrollPos = this.slider.scrollLeft;
    const index = Math.round(scrollPos / width);

    this.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("is-active");
      } else {
        dot.classList.remove("is-active");
      }
    });
  }
}

customElements.define("product-slider", ProductSlider);
